module.exports = __webpack_public_path__ + "static/media/icon-monday-dot-com.f4252b6b.svg";